//ThreePCalculator
import React, { useEffect, useState } from 'react'
import { useNavigate, Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useFetch from '../../hooks/useFetch';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrochip, faMicrophone, faSliders } from '@fortawesome/free-solid-svg-icons';
import adimage1 from '../../assets/pageimages/roomanywhere/raindeximg1.png';
import adimage2 from '../../assets/navlogo.png';
import { logout } from "../../redux/actions/authActions";

const ThreePCalculator = () => {
  const authState = useSelector(state => state.authReducer);
  const isLoggedIn = authState?.isLoggedIn || false;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const [fetchData, { loading }] = useFetch();
  const [userName, setUserName] = useState(authState.user.name);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
   };
  const [showAd, setShowAd] = useState(true);

  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [optimistic, setOptimistic] = useState("");
  const [mostLikely, setMostLikely] = useState("");
  const [pessimistic, setPessimistic] = useState("");

  const O = parseFloat(optimistic) || 0;
  const M = parseFloat(mostLikely) || 0;
  const P = parseFloat(pessimistic) || 0;

  const triangular = ((O + M + P) / 3).toFixed(2);
  const pert = ((O + 4 * M + P) / 6).toFixed(2);

  return (
    <div className='bg-black text-white [&_p]:text-white'>
      <div className="min-h-screen bg-black p-2 text-sm">
        <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
            <div className='flex flex-col'>
                <h2 className="text-lg lg:text-xl font-semibold text-yellow-200"> 
                    <FontAwesomeIcon icon={faSliders} className="mr-2 text-yellow-500" />
                    Think5Whys PTM 3P
                </h2>
                <h2 className="text-sm lg:text-lg text-gray-200">Practical Thinking Mathematics Three Point Estimation Tool</h2>
                <h2 className="text-xs lg:text-sm text-gray-400 mb-2">A Magical tool for Students, Teachers, Professionals, MSME Onwers, Workers, Children, Family, Government, Business</h2>
            </div>
            <div className="hidden md:flex items-center gap-3">
                {isLoggedIn ? (
                    <>
                    <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
                    <button
                        onClick={handleLogout}
                        className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                        title="Logout"
                    >
                        ⏻
                    </button>
                    </>
                ) : (
                    <>
                        <button
                            onClick={() => navigate("/login")}
                            className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
                        >
                            🔐 
                        </button>
                    </>
                )}
            </div>
            <button
            onClick={() => setIsMobileMenuOpen((s) => !s)}
            className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
            aria-label="Toggle menu"
            >
                {isMobileMenuOpen ? "×" : "☰"}
            </button>
        </header>

        {isMobileMenuOpen && (
            <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
            {isLoggedIn ? (
                <div className="flex flex-col items-center gap-3">
                <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                    <div className="flex gap-3">
                    <button
                        onClick={handleLogout}
                        className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                    >
                        ⏻
                    </button>
                    </div>
                </div>
            ) : (
                <div className="flex justify-center gap-6">
                <Link to="/login" className="text-teal-300">🔐</Link>
                </div>
            )}
            </div>
        )}
        { showAd && (
          <div
              className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
              onClick={() => navigate("/roomanywhere")}
          >
              <div className="flex-shrink-0 w-20 h-20 rounded overflow-hidden bg-gray-700">
              <img
                  src={adimage1} 
                  alt="Ad"
                  className="w-full h-full object-cover"
              />
              </div>
              <div className="flex flex-col text-left">
              <p className="text-xs uppercase text-gray-400 mb-1">Think5Whys Ad</p>
              <p className="font-semibold text-lg"><span className="text-yellow-200">RoomAnywhere</span>: Make Indoor and Outdoor Room (Patent Applied)</p>
              <p className="text-sm mt-1">Click to see more!</p>
              </div>
          </div>
        )}                

        <div className="bg-gray-900 text-white p-6 rounded-xl mt-8">
          <h2 className="text-xl font-bold text-yellow-200 mb-4">
            🧠 Think5Whys PTM 3P Calculator
          </h2>

          <p className="text-gray-300 mb-6">
            Enter your three estimates to calculate realistic productivity or time.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="text-purple-300 text-sm">Optimistic (O)</label>
              <input
                type="number"
                value={optimistic}
                onChange={(e) => setOptimistic(e.target.value)}
                className="w-full mt-1 p-2 rounded bg-black border border-gray-700"
                placeholder="Best case"
              />
            </div>
            <div>
              <label className="text-purple-300 text-sm">Most Likely (M)</label>
              <input
                type="number"
                value={mostLikely}
                onChange={(e) => setMostLikely(e.target.value)}
                className="w-full mt-1 p-2 rounded bg-black border border-gray-700"
                placeholder="Normal case"
              />
            </div>
            <div>
              <label className="text-purple-300 text-sm">Pessimistic (P)</label>
              <input
                type="number"
                value={pessimistic}
                onChange={(e) => setPessimistic(e.target.value)}
                className="w-full mt-1 p-2 rounded bg-black border border-gray-700"
                placeholder="Worst case"
              />
            </div>
          </div>
          <div className="mt-6 bg-black p-4 rounded-lg">
            <h3 className="text-purple-300 font-semibold mb-2">
              📊 Results
            </h3>
            <p className="text-gray-200">
              Triangular Estimate:{" "}
              <span className="text-yellow-200 font-semibold">{triangular}</span>
            </p>
            <p className="text-gray-200 mt-1">
              PERT Estimate:{" "}
              <span className="text-yellow-200 font-semibold">{pert}</span>
            </p>
          </div>
        </div>        
    </div>
    <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>    
  </div>
  );
};


export default ThreePCalculator;
